module.exports = __webpack_public_path__ + "img/ata-logo.b8df4321.png";